namespace advisorop.components.advisor {
    
    export class RTQListController{

        public rtqs: Array<domains.IRTQ>;
        public dgRTQSettings;        

        constructor(private advisorService: services.AdvisorService) {
            this.dgRTQSettings = {
                export: {
                    enabled: true,
                    fileName: "RTQs"
                },
                bindingOptions: {
                    dataSource: "vm.rtqs"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: "localStorage",
                    storageKey: "dgRTQSettings"
                },
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },                  
                /*
                <td><span ng-show="rt.questionnaireResult.status==0">In progress</span><span ng-show="rt.questionnaireResult.status==1">Completed</span></td>
                */
                columns: [
                    { dataField: 'questionnaireResult.dateStart', caption: 'Started', dataType: 'date', format: 'shortDate', visible: true },
                    { dataField: 'description', caption: 'Description', visible: true },
                    { dataField: 'lastRenewalDate', caption: 'Renewal date', dataType:'date', format:'shortDate', visible: true, width:90 },
                    { dataField: 'questionnaireResult.dateChanged', caption: 'Changed', dataType: 'date', format: 'shortDate', visible: true },
                    { dataField: 'questionnaireResult.dateFinished', caption: 'Finished', dataType: 'date', format: 'shortDate', visible: true },
                    { dataField: 'questionnaireResult.status', caption: 'Status', visible: true },                    
                    { dataField: 'score', caption: 'Scoring', visible: true },                    
                    { dataField: 'riskTolerance.name', caption: 'Risk Tolerance', visible: true },                    
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions', width:150 }                    
                ]
            };
        }

        renewRTQ(rtq: domains.IRTQ) {
            this.advisorService.renewRTQ(rtq)
                .success((data) => {
                    toastr.success("RTQ has been successfully renewed.");
                    rtq.lastRenewalDate = data.lastRenewalDate;
                })
                .error((data, status) => {
                    toastr.error("Error: " + status + " " + data);
                });
        }
        
        $onInit(): void {
        }
        
    }
    
    class RTQList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                rtqs: "<"
            };
            this.controller = ["advisorService", RTQListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/rtq-list.html';
        }
    }
    angular.module(Constants.APP).component("rtqList", new RTQList());

}